import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { ApplicationSchoolStatus } from 'searchality-data';
import DateService from 'services/Date.service';
import { School } from 'models/School';

import './ProfileMetadata.styles.scss';

type ProfileMetadataProps = {
  className?: string;
  appliedAt: string | Date;
  statusInSchool: ApplicationSchoolStatus;
  schools: School[];
  positionTitle: string;
  schoolGroupInfo: string;
};

const ProfileMetadata: React.FC<ProfileMetadataProps> = (props) => {
  const {
    className,
    statusInSchool,
    appliedAt,
    schools,
    positionTitle,
    schoolGroupInfo,
  } = props;

  const { t } = useTranslation();

  const classes = classNames('searchality-profile-metadata', className);

  return (
    <div className={classes}>
      <div className="status">{statusInSchool}</div>
      <div>
        <p className="title">{schoolGroupInfo}</p>
        <p className="description">{positionTitle}</p>
      </div>
      <div>
        <p className="title">{t('Profile.Metadata.schoolGroup')}</p>
        {schools?.map(({ name, _id }) => (
          <p className="description" key={_id}>
            {name}
          </p>
        ))}
      </div>
      <div>
        <p className="title">{t('Profile.Metadata.applicationDate')}</p>
        <p className="description">{DateService.getUSADateFormat(appliedAt)}</p>
      </div>
    </div>
  );
};

export default ProfileMetadata;
